import {
  doc,
  getDoc,
  query,
  getDocs,
  collection,
  where,
  addDoc,
  orderBy,
  limit,
  startAt,
  endAt
} from "firebase/firestore";
import { db } from "../Firebase";


const snippetsList = "snippets";


////////////////////////////////
// Snippet Data
////////////////////////////////

const getSnippetList = async (search) => {
  
  const returnlist = [];

  const collectionRef = collection(db, snippetsList);
  var q = query(collectionRef, orderBy('createdAt', 'desc'));

  if (search !== undefined) {
    let q1 = query(collectionRef, orderBy("title"), startAt(search), endAt(search + '~'));
    let q2 = query(collectionRef, orderBy("description"), startAt(search), endAt(search + '~'));

    let querySnapshotTitle = await getDocs(q1);
    let querySnapshotDesc = await getDocs(q2);

    querySnapshotTitle.forEach((doc) => {
      let a = doc.data();
      a.id = doc.id;
      returnlist.push(a);  /* { uid: "5nAEALwPegXQDzqKUwewYM18n9C2", location: "69231",...*/
    });
    
    querySnapshotDesc.forEach((doc) => {
      let a = doc.data();
      a.id = doc.id;
      returnlist.push(a);  /* { uid: "5nAEALwPegXQDzqKUwewYM18n9C2", location: "69231",...*/
    });
  } else {
    let querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      let a = doc.data();
      a.id = doc.id;
      returnlist.push(a);  /* { uid: "5nAEALwPegXQDzqKUwewYM18n9C2", location: "69231",...*/
    });
  }

  return returnlist;
}

const getRecentSnippetList = async () => {
  const returnlist = [];
  const collectionRef = collection(db, snippetsList);
  const q = query(collectionRef, orderBy('createdAt', 'desc'), limit(3))
  const querySnapshot = await getDocs(q);

  querySnapshot.forEach((doc) => {
    let a = doc.data();
    a.id = doc.id;
    returnlist.push(a);  /* { uid: "5nAEALwPegXQDzqKUwewYM18n9C2", location: "69231",...*/
  });

  return returnlist;
}

const getSnippetById = async (bid) => {
  const docRef = doc(db, snippetsList, bid);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data();
  }
}

const addSnippet = async (username, snippetDetails) => {

  let data = {
    createdAt: Date.now(),
    createdBy: username,
    title: snippetDetails.title,
    description: snippetDetails.description,
    howitworks: snippetDetails.howitworks,
    code: snippetDetails.code,
    language: snippetDetails.language,
    tags: snippetDetails.tags
  };
  await addDoc(collection(db, snippetsList), data);

}

////////////////////////////////
// User Data
////////////////////////////////

const fetchUserName = async (user) => {
  if (!user) { return; }
  try {
    const q = query(collection(db, "users"), where("uid", "==", user?.uid));
    const doc = await getDocs(q);
    const data = doc.docs[0].data();
    return data.name;
  } catch (err) {
    console.error(err);
  }
};

export {
  getSnippetList,
  getSnippetById,
  addSnippet,
  getRecentSnippetList,
  fetchUserName
}